import { render, staticRenderFns } from "./custom_pages.vue?vue&type=template&id=dc6076ea&scoped=true"
import script from "./custom_pages.vue?vue&type=script&lang=js"
export * from "./custom_pages.vue?vue&type=script&lang=js"
import style0 from "./custom_pages.vue?vue&type=style&index=0&id=dc6076ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6076ea",
  null
  
)

export default component.exports